import * as PropTypes from 'prop-types'

const WorkerCallShape = PropTypes.shape({})

export { WorkerCallShape }
